import RegularText from '@/components/RegularText';
import { PATH } from '@/constants/path';
import { checkDirtyField } from '@/helpers/compare';
import { widgetTextDefaultDetailSelector } from '@/redux/slice/widget.slice';
import { widgetTextDetailSelector } from '@/redux/slice/widgetText.slice';
import { Box, Icon, InlineStack } from '@shopify/polaris';
import { AlertCircleIcon } from '@shopify/polaris-icons';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export const WidgetAppearanceError = () => {
  const widgetTextDefaultDetail = useSelector(widgetTextDefaultDetailSelector);
  const widgetTextDetail = useSelector(widgetTextDetailSelector);

  const location = useLocation();

  const initialWidgetTextDefaultDetail = useRef(widgetTextDefaultDetail);

  const hasWidgetTextDefaultChanged = initialWidgetTextDefaultDetail.current.code !== widgetTextDefaultDetail.code;

  if (
    checkDirtyField(widgetTextDefaultDetail, widgetTextDetail).isDirty &&
    location.pathname === PATH.WIDGET.pathname &&
    (widgetTextDefaultDetail.code === widgetTextDetail.code || hasWidgetTextDefaultChanged)
  ) {
    return (
      <Box paddingInline={'300'} paddingBlock={'200'} paddingBlockEnd={'0'}>
        <InlineStack gap={'100'}>
          <Box color="text-critical">
            <Icon source={AlertCircleIcon} />
          </Box>
          <RegularText tone="critical" fontWeight="medium">
            Please save the content to show on widget
          </RegularText>
        </InlineStack>
      </Box>
    );
  }
};
